import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { assertRequiredEnv, getEnvValue } from '@/lib/safeEnv';
import ErrorBoundary from '@/components/ErrorBoundary';

// Assert required environment variables in production builds
// This ensures Vercel builds fail clearly if required keys are missing
if (import.meta.env.PROD) {
  try {
    assertRequiredEnv();
  } catch (err) {
    console.error('[ChurchHub] Environment variable validation failed:', err);
    // Re-throw to fail the build
    throw err;
  }
}

// Initialize Sentry error tracking (if configured)
if (getEnvValue('VITE_SENTRY_DSN')) {
  import('./lib/sentry').then(({ initSentry }) => {
    initSentry();
  });
}

// Suppress console.debug in production
if (import.meta.env.PROD) {
  console.debug = () => {};
}

// Client-only rendering (pure SPA - no SSR)
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Create root and render (no hydration needed - this is a pure SPA)
createRoot(rootElement).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
console.log('✅ Church Hub dashboard rendered');
